$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p == 'organizer_promo_code' && a == 'list') {

            let promo_code_new_ajax_lock = false;

            $(document).on("submit", "#promo-code-registration-form", function () {

                if (!promo_code_new_ajax_lock) {

                    promo_code_new_ajax_lock = true;

                    let url;
                    if ($("#promo-code-registration-form input[name=promo_code_id]").length) {
                        url = "/ajax/organizer_promo_code/update";
                    } else {
                        url = "/ajax/organizer_promo_code/new";
                    }
                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: {
                            serialized_post: $(this).serialize()
                        }
                    })
                        .done(function (data) {

                            if (data.html !== undefined && data.html !== null) {
                                popupAlert();
                                $('#promo-code-list').empty();
                                $('#promo-code-list').append(data.html);
                                if ($('#show-deactivated-promo-code-button').hasClass('d-none')) {
                                    $('#show-deactivated-promo-code-button').removeClass('d-none');
                                }
                                $("#promo-code-registration-form-modal").modal('hide');
                            }

                        })
                        .fail(function (data) {

                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }

                            if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                                prependAlert('#promo-code-registration-button-wrapper', data.responseJSON.error_message, 'danger', null, '#promo-code-registration-form')
                            }

                            promo_code_new_ajax_lock = false;

                        })
                        .always(function () {
                            promo_code_new_ajax_lock = false;
                        });

                }

                return false;

            });


        }

    }
);